import { createSelector } from 'reselect';
import MrdPodOverviewColumns from '../../containers/MrdPodOverviewColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.MRD_POD_OVERVIEW.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.MRD_POD_OVERVIEW.isLoading;

export const getData = ReportDefinitions.MRD_POD_OVERVIEW.getDataFunction();

export const getColumns = createSelector(
  getData,
  state => state.userData.userType,
  MrdPodOverviewColumns,
);
